export default "__VITE_ASSET__D3EFE_Am__"